import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditLocationComp from "./Component/EditLocationComp"


const EditLocation =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditLocationComp />
        </div>
        <Footer />
        </>
    )
}

export default EditLocation